import tw from "tailwind-styled-components";
import Model from "../Model";

const ViewDetail =({setViewDetail, selectedData})=>{

    return(
        <Model width={`w-11/12 max-w-lg`} setOpenModel={setViewDetail}>
            <Wrapper>
                <Title>View Details</Title>
                <div className="flex my-4">
                    <Id>#{selectedData?.clientId || "N/A"}</Id>
                </div>
                <Column>
                <FirstColumn>
                    <SubHeading>Difference</SubHeading>
                    <Paragraph>{selectedData?.difference || 0}</Paragraph>
                </FirstColumn> 
                <SecondColumn>
                    <SubHeading>No. Of Transaction</SubHeading>
                    <Paragraph>{selectedData?.noOfTransactions || 0}</Paragraph>
                </SecondColumn>
                </Column>
            </Wrapper>
        </Model>
    )
}

const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Id = tw.div`bg-cyan-600 text-white text-xs  inline-block py-1 max-w-fit px-3 flex items-center justify-center rounded-full`;
const Column = tw.div`grid grid-cols-2 my-3 gap-2`;
const FirstColumn = tw.div``;
const SecondColumn = tw.div``;
const SubHeading = tw.h2`text-xs text-blue-500 font-[600] mb-1`;
const Paragraph = tw.p`text-sm text-gray-900 font-semibold`;

export default ViewDetail;